export default {
    name: 'BlameLegend',
    legendCount: 10
};
